import "../Assets/CSS/Loading.css";

function LoadingPage() {
  return (
    <>
      <div className="loading-container">
        <div className="loading-content">Welcome To My Personal Website</div>
      </div>
    </>
  );
}

export default LoadingPage;
